import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { Check } from "lucide-react";
import * as React from "react";

const Checkbox = React.forwardRef<
  React.ComponentRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className: _className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className="peer h-4 w-4 shrink-0 rounded-sm border border-neutral-700 bg-neutral-900 ring-offset-black focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lumi-accent focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-lumi-accent data-[state=checked]:border-lumi-accent data-[state=checked]:text-black"
    {...props}
  >
    <CheckboxPrimitive.Indicator className="flex items-center justify-center text-current">
      <Check className="h-4 w-4" />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
